module.exports = __webpack_public_path__ + "img/bin.23c37cf0.svg";